import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import {
  CheckBoxParam,
  Input,
  Radio,
  RadioGroup,
  RadioParam,
  RequiredHelpPhrase,
  Row,
  Switch,
  TextParam,
} from '../../Form2';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';

type ImageUploadMetaDataProps = {
  alt: TextParam<'alt'> | undefined;
  caption: TextParam<'caption'> | undefined;
  size: RadioParam<'size', 'large' | 'medium' | 'small'>[] | undefined;
  popUp: CheckBoxParam<'popUp'> | undefined;
  copyright: TextParam<'copyright'> | undefined;
};
export function ImageUploadMetaData({
  alt,
  caption,
  size,
  popUp,
  copyright,
}: ImageUploadMetaDataProps) {
  const { t } = useSonTranslation('ImageUpload');

  return (
    <>
      {(alt || copyright) && <RequiredHelpPhrase />}
      {alt &&
        <Row>
          <Input
            label={t('pictureDescriptionLabel')}
            helpText={t('pictureDescriptionHelpText')}
            tooltipPlacement={TooltipPlacement.TOP}
            param={alt}
          />
        </Row>}
      {caption && <Row><Input label={t('pictureCaptionLabel')} param={caption} /></Row>}
      {size && size.length > 0 && (
        <RadioGroup
          legend={t('pictureSizeLabel')}
          // helpText={t('pictureSizeHelpText')}
          orientation="horizontal"
        >
          {size.map((radio) => {
            return (
              <Radio
                key={radio.value}
                label={t(`pictureSizeOptions.${radio.value}`)}
                param={radio}
              />);
          })}
        </RadioGroup>
      )}
      {popUp && (
        <Row>
          <Switch
            label={t('popUp')}
            helpText={t('popUpHelpText')}
            param={popUp}
          />
        </Row>
      )}
      {copyright &&
        <Row>
          <Input
            label={t('pictureCopyrightLabel')}
            helpText={t('pictureCopyrightHelpText')}
            tooltipPlacement={TooltipPlacement.TOP}
            param={copyright}
          />
        </Row>}
    </>
  );
}
